
import { 
  Link, 
  // Route, 
  // Routes, 
  useLocation
 } from 'react-router-dom';

const NavBarTabaItems = ({ componentName, changeComponent }) => {
  const { pathname, search } = useLocation();
  const tikNumURL = new URLSearchParams(search).get("TikNum");
  const systemCodeURL = new URLSearchParams(search).get("SystemCode");

  const CustomItem = ({ name, children, ...props }) => {
    return (
      <li className={"navbar-item" + (componentName === name ? " active" : "")}>
        {/* <a className={"navbar-link"} onClick={() => changeComponent(name)}>{children}</a> */}
        <Link to={`${pathname}?TikNum=${tikNumURL}&SystemCode=${systemCodeURL}&Page=${name}`} className={"navbar-link"} onClick={() => changeComponent(name)}>{children}</Link>
      </li>
    )
  }
  
  return (
    <nav className="navbar">
      <div className="container">
        <ul className="navbar-tabs">
          <CustomItem name="TamztitTabalInfo">תמצית תב''ע</CustomItem>
          <CustomItem name="ProcessInfo">תהליך אישור</CustomItem>
          <CustomItem name="VahadaInfo">החלטות הוועדה</CustomItem>
          <CustomItem name="ArchivInfo">ארכיב אופטי</CustomItem>
          <CustomItem name="TeurInfo">תיאור התכנית</CustomItem>
          <CustomItem name="LocationInfo">נתוני מיקום</CustomItem>
          <CustomItem name="HavotDaatInfo">חוות דעת נדרשות</CustomItem>
          <CustomItem name="YahasTohnitInfo">יחס לתוכניות אחרות</CustomItem>
        </ul>
      </div>
    </nav>
  )
}

export default NavBarTabaItems;